import styled from 'styled-components'

import Label from 'atoms/Label'

export const StyledCard = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  height: max-content;
`

export const StyledCardHeader = styled.div`
  background-color: #19b3ff;
  padding: 14px 23px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StyledCardBody = styled.div<{ show?: boolean }>`
  border: 1px solid #9e9e9e;
  border-top: none;
  box-sizing: border-box;
  display: ${(p) => (p.show ? 'block' : 'none')};
  opacity: ${(p) => (p.show ? 1 : 0)};
  transition: opacity 10s ease-in-out;
`

export const StyledUl = styled.ul`
  margin-top: 65px;
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  grid-row-gap: 6px;
`

export const StyledLi = styled.li`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  align-items: center;

  span {
    font-family: 'Roboto', sans-serif !important;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
  @media (max-width: 456px) {
    grid-template-columns: 1fr;
  }
`

export const StyledSliderContainer = styled.div`
  padding: 20px 15px;
  background-color: #f6f6f6;
`

export const StyledLabel = styled(Label)`
  /* font-size: 14px !important; */
  /* padding: 0 15px; */
`

export const StyledColumnContainer = styled.div<{ isPadding?: boolean }>`
  display: grid;
  grid-template-columns: auto 155px;
  align-items: center;
  padding-right: ${(p) => p.isPadding && '40px'};
  @media (max-width: 556px) {
    grid-template-columns: 1fr;
    margin-top: 10px;
    gap: 10px;
    padding-right: 0;
  }
`

export const StyledLinkButton = styled.a`
  cursor: pointer;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  text-decoration-line: underline;
  color: #19b3ff;
  margin-top: 47px;
  display: block;
  text-align: end;
`

export const StyledImageContainer = styled.div`
  position: relative;
  width: 336px;
  height: 164px;
  margin-top: 61px;
  overflow: hidden;

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    // left: 10%;
  }

  @media (max-width: 556px) {
    width: 100%;
    img {
      left: 0;
    }
  }
`

export const StyledContainer = styled.div``

export const StyledInnerContainer = styled.div`
  padding: 0 32px 20px;
  @media (max-width: 556px) {
    padding: 0 10px 10px;
  }
`

export const StyledSettingInnerContainer = styled.div`
  padding: 11px 13px 19px 17px;
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  grid-row-gap: 8px;
`

export const StyledRangeContainer = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-template-rows: max-content;
  grid-row-gap: 27px;
`

export const StyledColumnContainerEdit = styled(StyledColumnContainer)`
  grid-template-columns: auto 80px;
`

export const StyledToggleButton = styled.div`
  img {
    width: 30px;
  }
`

export const StyledInnerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
`

export const StyledInnerBody = styled.div<{ show?: boolean }>`
  border-top: none;
  box-sizing: border-box;
  display: ${(p) => (p.show ? 'block' : 'none')};
  opacity: ${(p) => (p.show ? 1 : 0)};
  transition: opacity 10s ease-in-out;
`
export const StyledToggleButtonInner = styled.div<{ show?: boolean }>`
  svg {
    transform: rotate(${(p) => (p.show ? 180 : 0)}deg);
    width: 10px;
  }
`

export const StyledTooltipTextGroup = styled.p`
  .padding_after {
    padding-bottom: 7px;
  }
`

export const StyledTooltipText = styled.p`
  color: white;
`